// Where a workspace artifact's bytes live, read off its stored content. Its own module rather than a corner
// of `artifact-image.ts` because it answers "does this content point at a URL", which is not an image
// question — and because both the image helpers and `wixel-link.ts` need it, which as a member of either of
// those files would be an import cycle.

import { parseFileRecordContent } from './file-record';

/** The artifact's URL: a FileRecord header's `rawUrl` when present (#7133 Phase 2), else the first http(s)
 *  URL embedded in the content (with trailing markdown/punctuation stripped) — or null. */
export function extractUrl(content?: string | null): string | null {
  if (!content) return null;
  const { header, body } = parseFileRecordContent(content);
  if (header?.rawUrl) return header.rawUrl;
  const match = body.match(/https?:\/\/[^\s)\]"'<>]+/i);
  return match ? match[0].replace(/[.,;:)\]}'"]+$/, '') : null;
}
